/** How many of the times of a sign-up event a guest can sign up for. Matches the TimeChoice enum in the API. */
export enum TimeChoice {
    /** The guest can sign up for several of the times. */
    Several = 0,
    /** The guest can only sign up for one of the times. */
    One = 1
}
